import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import ProjectCard from "../Projects/ProjectCards";
import Type from "./Type";
import profile from "../../Assets/profile.png";
import { featuredProjects } from "../../data/projects";

const capabilities = [
  {
    title: "Product Development",
    copy: "Web interfaces, backend services, and automated tests, from new features to fixes in existing applications.",
  },
  {
    title: "Platform Integrations",
    copy: "Data exchange and automated workflows between CRM, e-commerce, point-of-sale, and ERP systems.",
  },
  {
    title: "Research and Teaching",
    copy: "Simulation research and teaching support for mathematics and computer organization courses.",
  },
];

function Home() {
  return (
    <main>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row className="align-items-center gy-5 home-grid">
            <Col lg={7} className="home-copy">
              <h1
                className="hero-title hero-greeting"
                aria-label="Hello! in English, Japanese, and Chinese"
              >
                <Type />
              </h1>
              <p className="hero-lead">
                I&apos;m Dixon, a software engineer and Computer Science graduate from Universitas
                Indonesia. I build web applications, connect business systems, and write automated
                tests. My experience also includes university research and teaching.
              </p>
              <div className="hero-actions">
                <Link to="/project" className="primary-button">
                  View projects
                </Link>
                <Link to="/resume" className="ghost-button">
                  Open resume
                </Link>
              </div>
              <div className="hero-social-row">
                <span>Let&apos;s connect</span>
                <ul className="hero-social-list">
                  <li className="social-icons">
                    <a
                      href="https://github.com/dixonfrederick"
                      target="_blank"
                      rel="noreferrer"
                      className="hero-social-link"
                      aria-label="GitHub"
                    >
                      <AiFillGithub />
                    </a>
                  </li>
                  <li className="social-icons">
                    <a
                      href="https://www.linkedin.com/in/dixon-frederick/"
                      target="_blank"
                      rel="noreferrer"
                      className="hero-social-link"
                      aria-label="LinkedIn"
                    >
                      <FaLinkedinIn />
                    </a>
                  </li>
                  <li className="social-icons">
                    <a
                      href="https://www.instagram.com/dixon_fdrk"
                      target="_blank"
                      rel="noreferrer"
                      className="hero-social-link"
                      aria-label="Instagram"
                    >
                      <AiFillInstagram />
                    </a>
                  </li>
                </ul>
              </div>
            </Col>

            <Col lg={5}>
              <div className="hero-visual-shell">
                <img
                  src={profile}
                  alt="Dixon Frederick"
                  className="hero-portrait img-fluid"
                  width="460"
                  height="460"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>

      <section className="section-shell home-capability-section" aria-labelledby="experience-heading">
        <Container>
          <div className="section-header">
            <h2 id="experience-heading" className="section-eyebrow">Experience</h2>
          </div>
          <dl className="capability-list">
            {capabilities.map((item) => (
              <div className="capability-row" key={item.title}>
                <dt>{item.title}</dt>
                <dd>{item.copy}</dd>
              </div>
            ))}
          </dl>
        </Container>
      </section>

      <section className="section-shell">
        <Container>
          <div className="section-header">
            <h2 className="projects-heading-link">
              <Link to="/project" className="section-link projects-index-link">
                View All Projects
              </Link>
            </h2>
          </div>
          <Row className="g-4 project-grid">
            {featuredProjects.map((project) => (
              <Col md={6} key={project.title} className="project-card">
                <ProjectCard {...project} headingLevel="h3" />
              </Col>
            ))}
          </Row>
        </Container>
      </section>

    </main>
  );
}

export default Home;
